/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Api_Reference_Col_PurposeInputs */

const en_directory_api_reference_col_purpose = /** @type {(inputs: Directory_Api_Reference_Col_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purpose`)
};

const zh_directory_api_reference_col_purpose = /** @type {(inputs: Directory_Api_Reference_Col_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用途`)
};

/**
* | output |
* | --- |
* | "Purpose" |
*
* @param {Directory_Api_Reference_Col_PurposeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_api_reference_col_purpose = /** @type {((inputs?: Directory_Api_Reference_Col_PurposeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Api_Reference_Col_PurposeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_api_reference_col_purpose(inputs)
	return zh_directory_api_reference_col_purpose(inputs)
});
export { directory_api_reference_col_purpose as "directory.api_reference.col_purpose" }